import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizePreClaimsTypes } from './normalize';

export const fetchPreClaimsTypes = createProvider(api.fetchPreClaimsTypes)
  .andThen((res) => normalizePreClaimsTypes(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
